var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"video-container",attrs:{"align":"center","flat":""}},[_c('iframe',{staticClass:"video-frame",attrs:{"src":_vm.url,"scrolling":"no","allowfullscreen":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }